<div>
  <div id="general_search_table">
    <div id="general_search" *ngIf="hasEntitlements('SEARCH_CARDHOLDER')">
      <div class="row" *ngIf="ships">
        <form class="input-group" name="searchForm">
          <div class="col-sm-5 padding-0">
            <app-dropdown-select-control
              classes="form-control input-sm searhBoxheight"
              elementId="location"
              placeholder="Select Location (optional)"
              [searchTerm]="shipName"
              [source]="ships"
              (valueSelected)="selectShip($event)"
              (click)="showRecent = false"
            >
            </app-dropdown-select-control>
          </div>
          <div class="col-sm-5 padding-0">
            <input
              type="search"
              class="form-control"
              dropdown-toggle
              id="shipFirstParameter"
              (keyup.enter)="searchCardholders()"
              placeholder="Cardholders Search"
              [(ngModel)]="cardholderName"
              name="merchantName"
              (click)="showRecent = !showRecent"
            />
          </div>
          <div class="col-sm-2 padding-0">
            <span id="search_button" class="input-group-btn">
              <button
                class="btn btn-nc"
                type="button"
                (click)="searchCardholders()"
                [disabled]="!shipName && !cardholderName"
              >
                <i class="fa fa-search"></i>
              </button>
            </span>
          </div>
        </form>
      </div>
      <div class="row">
        <div class="col-xl-12">
          <ul
            class="dropdown-menu"
            [ngStyle]="{ display: showRecent ? 'block' : 'none' }"
            id="recentSearchesList"
          >
            <li class="recentSearchHeader">RECENT SEARCHES</li>
            <li *ngIf="recentSearches.length > 0">
              <div class="searchResults">
                <div
                  class="zeroPadding"
                  *ngFor="let cardholder of recentSearches"
                >
                  <div
                    class="row searchResultsRow"
                    (click)="selectCardholder(cardholder)"
                  >
                    <div class="col-md-11 ">
                      <div class="searchResultName">
                        <div>{{ cardholder.name }}</div>
                      </div>
                      <div class="searchResultDataName">
                        {{ cardholder.payGrade }}.{{
                          cardholder.militaryBranch
                        }}:
                        <span class="searchResultDataVal"
                          >{{ cardholder.shipName }}({{
                            cardholder.location
                          }})</span
                        >
                        | Card Number:
                        <span class="searchResultDataVal">{{
                          cardholder.cardNum | threeStars
                        }}</span>
                        | SSN:
                        <span class="searchResultDataVal">{{
                          cardholder.socialSecurity | slice: 5
                        }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
